<template lang="pug">
  div(data-testid="card")
    section.content-header(data-testid="content-header-bcard-detail")
      h1 {{data.full_name}} {{data.corporate_name}}

    section.content
      mixin btnbar
        .bcard-btnbar.clearfix(class!=attributes.class)
          router-link.btn.btn-default(:to="closeLocation")
            span(v-if="closeLocation.name === 'top'") TOPに戻る
            i.fa.fa-reply(v-else, title="戻る")

      +btnbar

      .card
        //router-link.close(:to="closeLocation") &times;
        ul.nav.nav-tabs
          li(:class="{active: $route.name === 'box-detail'}")
            router-link(:to="{ name: 'box-detail' }" data-testid="-tab-overall") 概要
          li(:class="{active: $route.name.indexOf('box-exchanger') === 0 }")
            router-link(:to="{ name: 'box-exchangers' }" data-testid="-tab-exchanger") 交換者
          li(:class="{active: $route.name.indexOf('box-history') === 0 }")
            router-link(:to="{ name: 'box-history' }" data-testid="-tab-history") 名刺履歴
          li(:class="{active: $route.name === 'box-concposts'}")
            router-link(:to="{ name: 'box-concposts' }" data-testid="-tab-concpost") 兼務情報
          //li(:class="{active: isTabSelected('tab-memo')}"): a(data-toggle="tab" href="#tab-memo") メモ
        .tab-content
          .tab-pane.active
            router-view(:value="data", @reload="getData", @delete="onDelete")
      portal-target(name="card-bottom")
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

let routeFrom = null

export default {
  name: 'Card',
  data () {
    return {
      data: {
        full_name: '---',
        person: {} // xxx of undefined対策
      }
    }
  },
  computed: {
    sidPerson () {
      return this.$route.params.sidPerson
    },
    closeLocation () {
      // 初期化フラグがある（名刺登録完了画面から遷移）場合や、どこから来たのか分からない場合
      if (this.$route.params.init || !routeFrom || !routeFrom.name || routeFrom.name === this.$route.name) {
        routeFrom = { name: 'top', params: {} }
      }
      delete routeFrom.params.init
      return {
        name: routeFrom.name,
        params: routeFrom.params,
        query: routeFrom.query
      }
    }
  },
  watch: {
    // storeのwatchの仕方は他にもある
    // https://stackoverflow.com/questions/43270159/vuejs-2-how-to-watch-store-values-from-vuex
    '$store.state.base.bcardListReloader' (bcardListReloader) {
      if (bcardListReloader) {
        this.getData()
      }
    },
    'sidPerson' () {
      this.getData()
    },
    '$route.name' () {
      this.getData('name')
    }
  },
  beforeRouteEnter (to, from, next) {
    routeFrom = from
    next()
  },
  created () {
    this.getData()
  },
  methods: {
    /**
     * 名刺情報を取得する
     * @param calledBy
     */
    getData (calledBy) {
      PersonRepository.getOverall({ sid_person: this.sidPerson }, this.isMgmt)
        .then((response) => {
          this.data = this.getApiData(response).data
        })
        .catch((error) => {
          let message = ''
          let type = ''

          // タブ間で移動しているときに名刺人物が無くなってしまった場合
          if (this.isErrorNotFound(error)) {
            if (calledBy === 'name') {
              message = '閲覧中の名刺情報は削除されました。'
              type = 'info'
            }
            else {
              message = '名刺情報を取得できませんでした。'
              type = 'danger'
            }
          }
          else {
            message = this.getErrorMessage(error) || '名刺情報を取得できませんでした。'
          }
          this.showToast(message, { type })
          setTimeout(() => {
            this.$router.push(this.closeLocation) // 閉じる
          }, 5000)
        })
    },
    onDelete () {
      this.$router.push(this.closeLocation) // 閉じる
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
  .card {
    border: 1px solid $table-border-color;

    //a.close {
    //  margin: 10px;
    //}

    .nav-tabs {
      background-color: #fff;

      > li {
        min-width: 100px;
        text-align: center;

        > a {
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
        }

        &.active > a {
          border: 0;
          border-bottom: 2px solid #555;
        }
      }
    }
  }
  .panel {
    margin: 0;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/box/Card.vue